module.exports = __webpack_public_path__ + "static/img/laoshi.3ccc64a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/laoshi.png
// module id = AboW
// module chunks = 0